// extracted by mini-css-extract-plugin
module.exports = {"Component":"Home_Component__1Zj8E"};